import { AxiosResponse } from "axios";
import api from "../api/base-api";

const getAll = (): Promise<AxiosResponse> => {
    return api.get("/categories");
};

export { getAll };
